export { BUILD_NUMBER, PROJECT_VERSION } from './version.cjs';
const EXECUTION_ERROR_TYPES = Object.freeze( {
    POTENTIAL_DUPLICATE_PROFILE: 'prompt:potential_duplicate_profile_confirmed'
} )

const SECTION_HANDLER = Object.freeze( {
    recipient_demographics_handler: 1,
    recipient_vitals_handler: 2,
    recipient_virology_handler: 3,
    recipient_journey_handler: 401,
    recipient_organ_details_handler: 4,
    recipient_transplant_details_handler: 5,
    recipient_post_transplant_followup_handler: 6,
    recipient_pancreas_specific_handler: 11,
    recipient_post_transplant_followup_pancreas_handler: 12,
    recipient_heart_specific_handler: 13,
    recipient_lung_specific_handler: 14,
    recipient_liver_specific_handler: 15,
    recipient_post_transplant_followup_liver_handler: 16,
    recipient_dialysis_handler: 403,
    recipient_donor_acceptance_criteria_handler: 402,
    recipient_donor_acceptance_criteria_kidney_cluster_handler: 404,
    recipient_donor_acceptance_criteria_pancreas_cluster_handler: 405,
    recipient_death_handler: 8,
    donor_demographics_handler: 7,
    donor_vitals_handler: 702,
    donor_virology_handler: 703,
    donor_donation_info_handler: 704,
    donor_link_recipient_handler: 705,
    donor_recovery_details_handler: 706,
    recipient_journey_pancreas_handler: 17,
    recipient_journey_kidney_handler: 18,
    recipient_pancreas_cluster_specific_handler: 19,
    recipient_kidney_cluster_specific_handler: 20,
    recipient_post_transplant_followup_pancreas_cluster_handler: 21,
    recipient_post_transplant_followup_kidney_cluster_handler: 22,
    recipient_dialysis_kidney_cluster_handler: 23,
} )

const ORGAN_MAP = Object.freeze( {
  "16": "Kidney",
  "4": "Pancreas",
  "8": "Liver",
  "64": "Heart",
  "2": "Lung",
  "128": "Islet",
  "32": "Intestine"
} )

const ORGAN_LIST = Object.freeze( {
  "Kidney": 3,
  "Pancreas": 6,
  "Liver": 1,
  "Heart": 2,
  "Lung": 4,
  "Islet": 6.5,
  "Intestine": 7
} )

const PATIENT_TYPES = Object.freeze( {
    RECIPIENT: { name: "Recipient", code: "2" },
    DONOR: { name: "Donor", code: "1" }
} )

const DEBUG_MESSAGE_TYPES = {
    SUCCESS: "success",
    ERROR: "error",
    WARNING: "warning",
    DEBUG: "debug",
    INFORMATION: "info"
  }
  const FHIR_SEVERITY = Object.freeze( {
    FATAL: "fatal",
    ERROR: "error",
    WARNING: "warning",
    INFORMATION: "information"
  } )
  const RECIPIENT_VIROLOGY_LOIN_CODES = [ '22244-8', '13949-3', '15377-5', '16714-8', '16715-5', '20475-0', '22239-8', '22241-4', '22246-3', '32170-3', '5121-9', '5122-7', '5124-3', '5125-0', '52976-8', '59838-3', '7851-9', '7852-7', '9513-3',
  '30325-5',
  '5195-3', '5196-1', '5197-9', '5196-1', '5197-9', '58452-4', '63557-3', '65633-0', '7905-3',
  '13952-7', '16933-4', '13919-6', '22316-4', '22318-0', '22319-8', '24113-3', '31204-1', '32685-0', '40725-4', '5185-4', '5186-2', '5187-0', '5188-8', '51914-0',
  '22322-2', '16935-9', '10900-9', '32019-2', '39535-0', '48070-7', '49177-9', '5193-8', '5194-6',
  '16935-9',
  '16128-1', '13955-0', '16129-9', '16936-7', '22327-1', '33462-3', '40726-2', '51824-1', '5198-7', '5199-5', '53376-0', '53376-0', '57006-9', 'XON14381-8',
  '210102716',
  '16982-1', '22362-8', '21348-8', '22363-6', '29901-6', '31431-0', '34318-6', '40735-3', '42769-0', '43007-4', '5226-6',
  '19162-7', '12271-3', '14306-5', '14307-3', '15410-4', '17763-4', '21594-7', '22600-1', '22602-7', '22603-5', '22604-3', '41512-5', '43978-6', '44771-4', '47419-7', '52978-4', '5401-5', '5402-3', '5403-1', '6569-8', '8046-5', '8047-3',
  '20479-2', '35275-7', '21501-2', '22499-8', '22502-9', '41501-8', '43976-0', '46197-0', '5242-3', '5243-1', '5244-9', '7961-6', '7962-4',
  '22415-4', '6476-6', '22414-7', '22417-0', '25418-5', '26942-3', '31503-6', '47412-2', '5249-8', '5250-6', '6477-4', '7965-7', '7966-5',
  '25514-1', '40667-8', '17550-5', '20458-6', '22496-4', '22497-2', '41763-4', '43810-1', '50694-9', '51931-4', '5330-6', '5331-4', '5332-2', '5333-0', '5334-8', '63462-6', '8013-5', '8014-3',
  '7883-2', '12212-7', '20432-1', '21260-5', '22296-8', '22297-6', '22298-4', '30083-0', '30138-2', '31372-6', '31374-2', '40753-6', '5155-7', '5156-5',
  '24114-1', '20490-9', '30136-6', '30339-6', '32828-6', '32829-4', '32830-2', '32843-5', '32844-3', '32845-0', '33395-5', '40750-2', '5157-3', '5158-1', '7885-7',
  '22587-0', '34147-9', '11597-2', '17723-8', '17724-6', '17725-3', '22590-4', '24110-9', '24312-1', '26009-1', '34382-2', '34954-8', '47236-5', '5392-6', '5393-4', '5394-2', '57032-5', '63464-2', '8041-6',
  'XON12263-0' ];
  const RECIPIENT_VIROLOGY_CODES_MAPPING = Object.freeze( {
    "22244-8": "CMV_IGG_AB",
    "13949-3": "CMV_IGG_AB",
    "15377-5": "CMV_IGG_AB",
    "16714-8": "CMV_IGG_AB",
    "16715-5": "CMV_IGG_AB",
    "20475-0": "CMV_IGG_AB",
    "22239-8": "CMV_IGG_AB",
    "22241-4": "CMV_IGG_AB",
    "22246-3": "CMV_IGG_AB",
    "32170-3": "CMV_IGG_AB",
    "5121-9": "CMV_IGG_AB",
    "5122-7": "CMV_IGG_AB",
    "5124-3": "CMV_IGG_AB",
    "5125-0": "CMV_IGG_AB",
    "52976-8": "CMV_IGG_AB",
    "59838-3": "CMV_IGG_AB",
    "7851-9": "CMV_IGG_AB",
    "7852-7": "CMV_IGG_AB",
    "9513-3": "CMV_IGG_AB",
    "30325-5": "CMV_IGM_AB",
    "7883-2": "EBV_NUCLEAR_AB",
    "12212-7": "EBV_NUCLEAR_AB",
    "20432-1": "EBV_NUCLEAR_AB",
    "21260-5": "EBV_NUCLEAR_AB",
    "22296-8": "EBV_NUCLEAR_AB",
    "22297-6": "EBV_NUCLEAR_AB",
    "22298-4": "EBV_NUCLEAR_AB",
    "30083-0": "EBV_NUCLEAR_AB",
    "30138-2": "EBV_NUCLEAR_AB",
    "31372-6": "EBV_NUCLEAR_AB",
    "31374-2": "EBV_NUCLEAR_AB",
    "40753-6": "EBV_NUCLEAR_AB",
    "5155-7": "EBV_NUCLEAR_AB",
    "5156-5": "EBV_NUCLEAR_AB",
    "24114-1": "EBV_CAPSID_AB",
    "20490-9": "EBV_CAPSID_AB",
    "30136-6": "EBV_CAPSID_AB",
    "30339-6": "EBV_CAPSID_AB",
    "32828-6": "EBV_CAPSID_AB",
    "32829-4": "EBV_CAPSID_AB",
    "32830-2": "EBV_CAPSID_AB",
    "32843-5": "EBV_CAPSID_AB",
    "32844-3": "EBV_CAPSID_AB",
    "32845-0": "EBV_CAPSID_AB",
    "33395-5": "EBV_CAPSID_AB",
    "40750-2": "EBV_CAPSID_AB",
    "5157-3": "EBV_CAPSID_AB",
    "5158-1": "EBV_CAPSID_AB",
    "7885-7": "EBV_CAPSID_AB",
    "5195-3": "HBV_SURFACE_AG",
    "5196-1": "HBV_SURFACE_AG",
    "5197-9": "HBV_SURFACE_AG",
    "58452-4": "HBV_SURFACE_AG",
    "63557-3": "HBV_SURFACE_AG",
    "65633-0": "HBV_SURFACE_AG",
    "7905-3": "HBV_SURFACE_AG",
    "13952-7": "HBV_CORE_AB",
    "16933-4": "HBV_CORE_AB",
    "13919-6": "HBV_CORE_AB",
    "22316-4": "HBV_CORE_AB",
    "22318-0": "HBV_CORE_AB",
    "22319-8": "HBV_CORE_AB",
    "24113-3": "HBV_CORE_AB",
    "31204-1": "HBV_CORE_AB",
    "32685-0": "HBV_CORE_AB",
    "40725-4": "HBV_CORE_AB",
    "5185-4": "HBV_CORE_AB",
    "5186-2": "HBV_CORE_AB",
    "5187-0": "HBV_CORE_AB",
    "5188-8": "HBV_CORE_AB",
    "51914-0": "HBV_CORE_AB",
    "22322-2": "HBV_AB",
    "16935-9": "HBV_AB",
    "10900-9": "HBV_AB",
    "32019-2": "HBV_AB",
    "39535-0": "HBV_AB",
    "48070-7": "HBV_AB",
    "49177-9": "HBV_AB",
    "5193-8": "HBV_AB",
    "5194-6": "HBV_AB",
    "16128-1": "HCV_AB",
    "13955-0": "HCV_AB",
    "16129-9": "HCV_AB",
    "16936-7": "HCV_AB",
    "22327-1": "HCV_AB",
    "33462-3": "HCV_AB",
    "40726-2": "HCV_AB",
    "51824-1": "HCV_AB",
    "5198-7": "HCV_AB",
    "5199-5": "HCV_AB",
    "53376-0": "HCV_AB",
    "57006-9": "HCV_AB",
    "XON14381-8": "HCV_AB",
    "210102716": "HBV_NAT",
    "XON12263-0": "HIV",
    "16982-1": "HTLV1",
    "22362-8": "HTLV1",
    "21348-8": "HTLV1",
    "22363-6": "HTLV1",
    "29901-6": "HTLV1",
    "31431-0": "HTLV1",
    "34318-6": "HTLV1",
    "40735-3": "HTLV1",
    "42769-0": "HTLV1",
    "43007-4": "HTLV1",
    "5226-6": "HTLV1",
    "22587-0": "VDRL",
    "34147-9": "VDRL",
    "11597-2": "VDRL",
    "17723-8": "VDRL",
    "17724-6": "VDRL",
    "17725-3": "VDRL",
    "22590-4": "VDRL",
    "24110-9": "VDRL",
    "24312-1": "VDRL",
    "26009-1": "VDRL",
    "34382-2": "VDRL",
    "34954-8": "VDRL",
    "47236-5": "VDRL",
    "5392-6": "VDRL",
    "5393-4": "VDRL",
    "5394-2": "VDRL",
    "57032-5": "VDRL",
    "63464-2": "VDRL",
    "8041-6": "VDRL",
    "19162-7": "VZV_AB",
    "12271-3": "VZV_AB",
    "14306-5": "VZV_AB",
    "14307-3": "VZV_AB",
    "15410-4": "VZV_AB",
    "17763-4": "VZV_AB",
    "21594-7": "VZV_AB",
    "22600-1": "VZV_AB",
    "22602-7": "VZV_AB",
    "22603-5": "VZV_AB",
    "22604-3": "VZV_AB",
    "41512-5": "VZV_AB",
    "43978-6": "VZV_AB",
    "44771-4": "VZV_AB",
    "47419-7": "VZV_AB",
    "52978-4": "VZV_AB",
    "5401-5": "VZV_AB",
    "5402-3": "VZV_AB",
    "5403-1": "VZV_AB",
    "6569-8": "VZV_AB",
    "8046-5": "VZV_AB",
    "8047-3": "VZV_AB",
    "20479-2": "MEASLES_AB",
    "35275-7": "MEASLES_AB",
    "21501-2": "MEASLES_AB",
    "22499-8": "MEASLES_AB",
    "22502-9": "MEASLES_AB",
    "41501-8": "MEASLES_AB",
    "43976-0": "MEASLES_AB",
    "46197-0": "MEASLES_AB",
    "5242-3": "MEASLES_AB",
    "5243-1": "MEASLES_AB",
    "5244-9": "MEASLES_AB",
    "7961-6": "MEASLES_AB",
    "7962-4": "MEASLES_AB",
    "22415-4": "MUMPS_AB",
    "6476-6": "MUMPS_AB",
    "22414-7": "MUMPS_AB",
    "22417-0": "MUMPS_AB",
    "25418-5": "MUMPS_AB",
    "26942-3": "MUMPS_AB",
    "31503-6": "MUMPS_AB",
    "47412-2": "MUMPS_AB",
    "5249-8": "MUMPS_AB",
    "5250-6": "MUMPS_AB",
    "6477-4": "MUMPS_AB",
    "7965-7": "MUMPS_AB",
    "7966-5": "MUMPS_AB",
    "25514-1": "RUBELLA_AB",
    "40667-8": "RUBELLA_AB",
    "17550-5": "RUBELLA_AB",
    "20458-6": "RUBELLA_AB",
    "22496-4": "RUBELLA_AB",
    "22497-2": "RUBELLA_AB",
    "41763-4": "RUBELLA_AB",
    "43810-1": "RUBELLA_AB",
    "50694-9": "RUBELLA_AB",
    "51931-4": "RUBELLA_AB",
    "5330-6": "RUBELLA_AB",
    "5331-4": "RUBELLA_AB",
    "5332-2": "RUBELLA_AB",
    "5333-0": "RUBELLA_AB",
    "5334-8": "RUBELLA_AB",
    "63462-6": "RUBELLA_AB",
    "8013-5": "RUBELLA_AB",
    "8014-3": "RUBELLA_AB"
  }
   )
   const LIVING_DONOR_VIROLOGY_CODES_MAPPING = Object.freeze( {
    'TXP#16510': 'HBV_CORE_AB',
    'TXP#16511': 'HBV_AB',
    'TXP#16512': 'CMV_IGG_AB',
    'TXP#16513': 'HBV_SURFACE_AG',
    'TXP#16514': 'HCV_AB',
    'TXP#16515': 'HIV',
    'TXP#16516': 'VDRL',
    'TXP#16517': 'EBV_CAPSID_AB',
    'TXP#16518': 'WEST_NILE_IGM',
  }
  )
  
 
export { EXECUTION_ERROR_TYPES, SECTION_HANDLER, PATIENT_TYPES, DEBUG_MESSAGE_TYPES, FHIR_SEVERITY, RECIPIENT_VIROLOGY_LOIN_CODES,
   RECIPIENT_VIROLOGY_CODES_MAPPING, LIVING_DONOR_VIROLOGY_CODES_MAPPING, ORGAN_MAP, ORGAN_LIST };

